import styled, { css } from "react-emotion/macro"

export const Wrapper = styled("div")`
  ${({ gradient, image, styles }) =>
    css`
      background: ${gradient}, url(${image});
      background-size: cover;
      background-position: center center;

      ${styles};
    `};
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Marquee/style.js